module.exports = __webpack_public_path__ + "media/images/sampleBet__kranz-cb01d51c120e7969ac27b0ba2d8ce54f.png";